import { EventType } from '../../domain/webhook/EventType';
import { Webhook } from '../../domain/webhook/Webhook';
import { WebhookDTO } from '../../domain/webhook/WebhookDTO';

export class WebhookMapper {
  static toDomain(raw: WebhookDTO): Webhook {
    const {
      id,
      created_at,
      created_by,
      deleted_at,
      enabled,
      enabled_events,
      failure_count,
      organization_id,
      project_id,
      updated_at,
      url,
      api_version,
    } = raw;

    return Webhook.create(
      {
        organization_id,
        project_id,
        enabled,
        enabled_events: enabled_events as EventType[],
        created_by,
        url,
        created_at,
        deleted_at,
        updated_at,
        failure_count,
        api_version: api_version ? api_version : 1,
      },
      id
    );
  }

  toDTO(webhook: Webhook): WebhookDTO {
    const {
      id,
      created_at,
      created_by,
      deleted_at,
      enabled,
      enabled_events,
      failure_count,
      organization_id,
      project_id,
      updated_at,
      url,
    } = webhook;

    return {
      id,
      created_at,
      created_by,
      deleted_at,
      enabled,
      enabled_events,
      failure_count,
      organization_id,
      project_id,
      updated_at,
      url,
    };
  }
}
